var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconOutput48Line = function SvgIconOutput48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7 14.599c0-2.92-2.38-5.3-5.3-5.3H14.6a5.31 5.31 0 0 0-5.3 5.3v18.8c0 2.92 2.38 5.3 5.3 5.3h18.8c2.92 0 5.3-2.38 5.3-5.3v-1.4h-3.4v1.4a1.9 1.9 0 0 1-1.9 1.9H14.6a1.9 1.9 0 0 1-1.9-1.9v-18.8c0-1.05.85-1.9 1.9-1.9h18.8c1.05 0 1.9.85 1.9 1.9v1.4h3.4v-1.4Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m32.01 31.609 5.79-5.51c.57-.54.9-1.31.9-2.1s-.33-1.56-.9-2.1l-5.79-5.51-2.34 2.46 3.62 3.45h-12.4v3.4H33.3l-3.62 3.45 2.34 2.46h-.01Z",
    fill: "current"
  })));
};
export default SvgIconOutput48Line;